/* 
 * SELECTS SHOPIFY PAYMENT BUTTON, AND CHANGES DEFAULT BUTTON TEXT 'BUY it now' TO 'Buy now'
*/

document.addEventListener("DOMContentLoaded", function () {
    const buyItNowBtns = document.querySelectorAll('shopify-buy-it-now-button button.shopify-payment-button__button');
    if (buyItNowBtns.length != 0) {
        buyItNowBtns.forEach(buyItNowBtn => buyItNowBtn.textContent = "Buy now");
    }
});